import { containerRelocatedDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getcontainerRelocatedEn = () => {
  const data = containerRelocatedDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addcontainerRelocated = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-get-my-container-relocated`,
    ) &&
    document.getElementById(`containerRelocatedJSONLD`) === null
  ) {
    const script = containerRelocatedJSONLDEn()
    addJSONLDToHead(script, `containerRelocatedJSONLD`)
  } else {
    removeElement(`containerRelocatedJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const containerRelocatedJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getcontainerRelocatedEn(),
  }
  return FaqBagsterTemplate
}
